import React from 'react'
import classNames from 'classnames'
import { Button, ButtonProps } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

interface ButtonIconProps extends ButtonProps {
    /** FontAwesome icon descriptor */
    icon: IconProp
    /** Which side of the label the icon is rendered on */
    iconAlign?: 'left' | 'right'
    /** Extra CSS class(es) applied to the icon element */
    iconClassName?: string
    /** FontAwesomeIcon power-transform string */
    transform?: string
    /** Button label content */
    children?: React.ReactNode
}

/**
 * Reactstrap `Button` with an embedded FontAwesome icon and configurable alignment.
 */
const ButtonIcon = ({
    icon,
    iconAlign = 'left',
    iconClassName,
    transform,
    children,
    ...rest
}: ButtonIconProps) => (
    <Button {...rest}>
        {iconAlign === 'right' && children}
        <FontAwesomeIcon
            icon={icon}
            className={classNames(iconClassName, {
                'mr-1': children && iconAlign === 'left',
                'ml-1': children && iconAlign === 'right',
            })}
            transform={transform}
        />
        {iconAlign === 'left' && children}
    </Button>
)

export default ButtonIcon
